<template>
  <div class="app">
    <header class="site-header">
      <a class="site-logo" href="/">
        <img :src="logoUrl" alt="滋仙草" class="site-logo__image" width="120" height="40">
      </a>
      <nav class="site-nav">
        <a
          v-for="link in navLinks"
          :key="link.path"
          :href="link.path"
          :aria-current="isCurrent(link.path) ? 'page' : undefined"
        >{{ link.label }}</a>
      </nav>
      <a
        v-if="contact.active"
        class="contact-entry"
        :href="contact.url"
        target="_self"
        referrerpolicy="no-referrer"
      >加好友</a>
    </header>
    <main class="site-main">
      <router-view />
    </main>
    <ContactFooter />
  </div>
</template>

<script>
import { RouterView } from 'vue-router'
import ContactFooter from '@/components/ContactFooter.vue'
import rawContactConfig from '@/config/contact.json'
import { validateContactConfig } from '@/contact/contactPolicy.mjs'
import { BRAND_LOGO_URL, NAV_LINKS } from '@/content/siteContent.mjs'
import { usePageMeta } from '@/content/usePageMeta.mjs'

export default {
  name: 'App',
  components: {
    RouterView,
    ContactFooter
  },
  setup() {
    usePageMeta()
    return {
      navLinks: NAV_LINKS,
      logoUrl: BRAND_LOGO_URL,
      contact: validateContactConfig(rawContactConfig)
    }
  },
  methods: {
    /**
     * @param {string} path
     * @returns {boolean}
     */
    isCurrent(path) {
      const current = this.$route.path === '/' ? '/' : `${this.$route.path}.html`
      if (path === '/products.html') return current.startsWith('/products')
      return current === path
    }
  }
}
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background: linear-gradient(135deg, #f5f0ff 0%, #e8e0ff 50%, #f0e6ff 100%);
  min-height: 100vh;
}

.app {
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: transparent;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.site-main {
  flex: 1;
}
</style>
